/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBTITLE = {
    Mr: 'MR',
    Mrs: 'MRS',
    Ms: 'MS',
    Miss: 'MISS',
    Dr: 'DOCTOR',
    Bishop: 'BISHOP',
    Captain: 'CAPTAIN',
    Father: 'FATHER',
    Judge: 'JUDGE',
    Lady: 'LADY',
    Master: 'MASTER',
    Professor: 'PROFESS',
    Sir: 'SIR',
    Colonel: 'COLONEL',
    Major: 'MAJOR',
    Princess: 'PRINC',
    Prince: 'PRINCE',
    Admiral: 'ADMIRAL',
    Advocate: 'ADVOCATE',
    Brigadier: 'BRIGADIER',
    Commissioner: 'COMMISSIONER',
    Commodore: 'COMMODORE',
    Director: 'DIRECTOR',
    Doctor: 'DOCTOR2',
    EstLate: 'ESTLATE',
    General: 'GENERAL',
    Honourable: 'HONOURABLE',
    Inspector: 'INSPECTOR',
    LieutCol: 'LIEUTCOL',
    Lieutenant: 'LIEUTENANT',
    LtCmdr: 'LTCMDR',
    Magistrate: 'MAGISTRATE',
    Minister: 'MINISTER',
    Pastor: 'PASTOR',
    President: 'PRESIDENT',
    Rabbi: 'RABBI',
    Reverend: 'REVEREND',
    Sergeant: 'SERGEANT',
    Sister: 'SISTER',
    Sup: 'SUP',
    SnrSup: 'SNRSUP',
    TheHon: 'THEHON',
    MajorGen: 'MAJORGEN',
    Mayor: 'MAYOR'
} as const;
export type GHUBTITLE = typeof GHUBTITLE[keyof typeof GHUBTITLE];


export function GHUBTITLEFromJSON(json: any): GHUBTITLE {
    return GHUBTITLEFromJSONTyped(json, false);
}

export function GHUBTITLEFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBTITLE {
    return json as GHUBTITLE;
}

export function GHUBTITLEToJSON(value?: GHUBTITLE | null): any {
    return value as any;
}

